// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Lf3D","description":"PatientConsentPreview_description__Tr_dI"};